<div>
  <div class="border-b border-gray-100 p-3 md:p-4">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <mat-icon class="text-purple-500">person</mat-icon>
        <span class="text-xl font-semibold text-gray-800">Candidate Details</span>
      </div>
      @if (showCloseButton) {
      <button (click)="close()" mat-icon-button class="text-gray-500 hover:text-gray-700 transition-colors">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      }
    </div>
  </div>
  <div class="p-3 md:p-4">
    <div class="space-y-4">

      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <mat-icon class="text-purple-500 min-w-fit">{{candidate?.gender === 'Male' ? 'man' : candidate?.gender ===
            'Female' ? 'woman' : 'person'}}</mat-icon>
          <div class="space-y-2 w-full">
            <h3 class="text-sm font-medium text-gray-500">Name</h3>
            <p class="text-gray-800">{{ candidate?.candidate_name }}</p>
          </div>
        </div>
      </div>

      <!-- Basic Info Section -->
      <div class="flex space-x-4">

        <div class="bg-gray-50 rounded-lg p-3 md:p-4 flex-1 transition-colors">
          <div class="flex items-center space-x-3">
            <mat-icon class="text-purple-500 min-w-fit">schedule</mat-icon>
            <div>
              <h3 class="text-sm font-medium text-gray-500">Total Work Experience</h3>
              <p class="text-gray-800 mt-1">
                {{candidate?.resume_analysis?.resume_analysis?.total_experience}}</p>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg p-3 md:p-4 flex-1 transition-colors">
          <div class="flex items-center space-x-3">
            <mat-icon class="text-purple-500 min-w-fit">location_on</mat-icon>
            <div>
              <h3 class="text-sm font-medium text-gray-500">UAE Work Experience</h3>
              <p class="text-gray-800 mt-1">{{candidate?.resume_analysis?.resume_analysis?.total_uae_experience || 'Not Stated'}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Demographic Details -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <mat-icon class="text-purple-500 min-w-fit">badge</mat-icon>
          <div class="space-y-3 w-full">
            <div class="flex justify-between items-center pb-2 border-b border-gray-200">
              <span class="text-sm font-medium text-gray-500">Nationality</span>
              <span class="text-gray-800">{{candidate?.resume_analysis?.resume_analysis?.nationality || 'Not
                Stated'}}</span>
            </div>
            <div class="flex justify-between items-center pb-2 border-b border-gray-200">
              <span class="text-sm font-medium text-gray-500">Gender</span>
              <span class="text-gray-800">{{candidate?.resume_analysis?.resume_analysis?.gender || 'Not Stated'}}</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm font-medium text-gray-500">Age</span>
              <span class="text-gray-800">{{candidate?.resume_analysis?.resume_analysis?.age || 'Not Stated'}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Education Details -->
      @if(candidate?.resume_analysis?.education?.length > 0) {
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <mat-icon class="text-purple-500 min-w-fit">school</mat-icon>
          @for(item of candidate?.resume_analysis?.education;track item?.college_name) {
          <div class="space-y-2 w-full">
            <h3 class="text-sm font-medium text-gray-500">Education</h3>
            <p class="font-semibold text-gray-800">{{item?.degree}}</p>
            <p class="text-sm text-gray-600 mt-1">{{item?.college_name}}</p>
            <div class="flex items-center mt-2">
              <mat-icon class="text-gray-400 text-sm mr-1">location_on</mat-icon>
              <span class="text-sm text-gray-500">{{item?.location || 'Not Stated'}}</span>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>
